import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { tscope } from '@i18n';
import { getKillSessionMessage } from '@config/index';
import { selectKillSessionReason } from '@reducks/session';
import { useUserQuery } from '@navigators/Root/App/hooks';
import { useEventListener } from './useEventListener';

export const useController = () => {
  const [showModal, setShowModal] = useState(null);
  const { data: useData } = useUserQuery();
  const email = useData?.user?.email;
  const killSessionReason = useSelector(selectKillSessionReason);
  const description = getKillSessionMessage({ t: tscope('Common'), reason: killSessionReason });

  useEffect(() => {
    if (killSessionReason) setShowModal(true);
    else setShowModal(false);
  }, [killSessionReason]);

  useEventListener();

  return {
    email,
    showModal,
    description,
  };
};
